import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/306'

const AverageActiveCustomersPerLocationPerMonthTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="looker.urls.dashboards/306"
  />
)

export default AverageActiveCustomersPerLocationPerMonthTab
